import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";

declare var ko: any;

export class configSuggestedArticles_template extends vnTemplate{

    protected filterListingPageTemplate: filterListingPage_template;
    protected filterShowMoreListingPageTemplate: filterListingPage_template;


    protected getTemplateHtml(): string{
        let myThis = this;
        return /*html*/ `
            <div class="w-form w-form-large">
                <div class="form-header">
                    <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button>
                    <!--<h3 class="form-title">Infinite Scroll Config</h3>-->
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Recommended/Related</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                              <dl class="double-list">
                                    <dt style="border-bottom: none">
                                        <span><h1><b>Regular</b></h1></span>
                                    </dt>
                                    <dd style="border-bottom: none"></dd>
                                    <dt>
                                        <span>Minimum Article Pool</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: infiniteScrollMinArticles"></span>
                                    </dd>
                                    <dt>
                                        <span>Maximum Article Pool</span>
                                    </dt>                                    
                                    <dd >
                                        <span data-bind="text: infiniteScrollMaxArticles"></span>
                                    </dd>
                                    <dt style="border-bottom: none">
                                        <span><h1><b>Video</b></h1></span>
                                    </dt>
                                    <dd style="border-bottom: none"></dd>
                                    <dt>
                                        <span>Minimum Video Pool</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: infiniteScrollMinArticles"></span>
                                    </dd>
                                    <dt>
                                        <span>Maximum Video Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: infiniteScrollMaxArticles"></span>
                                    </dd>
                                    <dt style="border-bottom: none">
                                        <span><h1><b>Threads</b></h1></span>
                                    </dt>
                                    <dd style="border-bottom: none"></dd>
                                    <dt>
                                        <span>Maximum Thread Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: threadMaxArticles"></span>
                                    </dd>
                                    <dt>
                                        <span>Minimum Thread Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: threadMinArticles"></span>
                                    </dd>
                                      
                                 </dl>
                         </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th><span>Priority</span></th>
                                        <th><span>Description</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: infiniteScrollRules">
                                    <tr class="cursor">
                                        <td><span data-bind="text: position"></span></td>
                                        <td><span data-bind="html: description"></span></td>                          
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Trending/Popular</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                              <dl class="double-list">
                                    <dt style="border-bottom: none">
                                        <span><h1><b>Regular</b></h1></span>
                                    </dt>
                                    <dd style="border-bottom: none"></dd>
                                    <dt>
                                        <span>Minimum Article Pool</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: trendingMinArticles"></span>
                                    </dd>
                                    <dt>
                                        <span>Maximum Article Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: trendingMaxArticles"></span>
                                    </dd>
                                    <dt style="border-bottom: none">
                                        <span><h1><b>Video</b></h1></span>
                                    </dt>
                                    <dd style="border-bottom: none"></dd>
                                    <dt>
                                        <span>Minimum Video Pool</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: trendingMinArticles"></span>
                                    </dd>
                                    <dt>
                                        <span>Maximum Video Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: trendingMaxArticles"></span>
                                    </dd>
                                    <dt style="border-bottom: none">
                                        <span><h1><b>Thread</b></h1></span>
                                    </dt>
                                    <dd style="border-bottom: none"></dd>
                                    <dt>
                                        <span>Maximum Thread Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: threadMaxArticles"></span>
                                    </dd>
                                    <dt>
                                        <span>Minimum Thread Pool</span>
                                    </dt>
                                    <dd >
                                        <span data-bind="text: threadMinArticles"></span>
                                    </dd>  
                                 </dl>
                         </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th><span>Priority</span></th>
                                        <th><span>Description</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: trendingRules">
                                    <tr class="cursor">
                                        <td><span data-bind="text: position"></span></td>
                                        <td><span data-bind="html: description"></span></td>                          
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <strong class="form-sub-title">Trending/Popular (Full List)</strong>
                    </div>
                </div>
                <div class="w-form-body">
                    <div class="form-body">
                        <div class="form-group">
                              <dl class="double-list">
                                    <dt>
                                        <span>Minimum Article Pool</span>
                                    </dt>
                                    <dd>
                                        <span>NULL</span>
                                    </dd>
                                    <dt>
                                        <span>Maximum Article Pool</span>
                                    </dt>
                                    <dd >
                                        <span>NULL</span>
                                    </dd>  
                                 </dl>
                         </div>
                    </div>
                    <div class="form-body">
                        <div class="form-group">
                            <table class="list-results">
                                <thead>
                                    <tr>
                                        <th><span>Priority</span></th>
                                        <th><span>Description</span></th>
                                    </tr>
                                </thead>
                                <tbody data-bind="foreach: fullListRules">
                                    <tr class="cursor">
                                        <td><span data-bind="text: position"></span></td>
                                        <td><span data-bind="html: description"></span></td>                          
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
        `;

    }

    protected initPartial(): void {

        this.filterListingPageTemplate = new filterListingPage_template("filterListingPageTemplate", this.getTemplateViewModel(), this.caller);
        this.filterListingPageTemplate.setPlaceholder("Main Hub Page");

        this.filterShowMoreListingPageTemplate = new filterListingPage_template("filterShowMoreListingPageTemplate", this.getTemplateViewModel(), this.caller);
        this.filterShowMoreListingPageTemplate.setPlaceholder('Show More Hub Page');

    }

    protected getTemplateName(): string{
        return "configSuggestedArticles-template";
    }

    /*protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {

        return ["div", "config-infinite-scroll"];
    }*/

    protected buildViewModel(): any{

        let self = this;
        return  {
            infiniteScrollRules: ko.observableArray([]),
            infiniteScrollMinArticles: ko.observable(null),
            infiniteScrollMaxArticles: ko.observable(null),
            trendingRules: ko.observableArray([]),
            fullListRules: ko.observableArray([]),
            trendingMinArticles: ko.observable(null),
            trendingMaxArticles: ko.observable(null),
            threadMaxArticles: ko.observable(null),
            threadMinArticles: ko.observable(null),
            onClickCancel: function (data, event) {
                self.onClickCancel()
            },
        };
    }


    public setInfiniteScrollRules(infiniteScrollRules): void {

        this.getTemplateViewModel().infiniteScrollRules(infiniteScrollRules);
    }

    public setInfiniteScrollMinArticles(minArticles): void {

        this.getTemplateViewModel().infiniteScrollMinArticles(minArticles);
    }

    public setInfiniteScrollMaxArticles(maxArticles): void {

        this.getTemplateViewModel().infiniteScrollMaxArticles(maxArticles);
    }


    public setTrendingRules(trendingRules): void {

        this.getTemplateViewModel().trendingRules(trendingRules);
    }

    public setFullListRules(fullListRules): void {

        this.getTemplateViewModel().fullListRules(fullListRules);
    }

    public setTrendingMinArticles(trendingMinArticles): void {

        this.getTemplateViewModel().trendingMinArticles(trendingMinArticles);
    }

    public setTrendingMaxArticles(trendingMaxArticles): void {

        this.getTemplateViewModel().trendingMaxArticles(trendingMaxArticles);
    }

    public onClickCancel(): void {

        this.caller.cancelForm();
    }

    public setThreadMaxArticles(threadMaxArticles): void {

        this.getTemplateViewModel().threadMaxArticles(threadMaxArticles);
    }

    public setThreadMinArticles(threadMinArticles): void {

        this.getTemplateViewModel().threadMinArticles(threadMinArticles);
    }

    /*public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }*/
}


// WEBPACK FOOTER //
// ./js/components/templates/configSuggestedArticles_template.ts